<template>
  <b-field
    v-if="value && field.label"
    horizontal
    class="field"
    :label="field.label"
    :type="hasError ? 'is-danger' : ''"
    :message="errorMessage"
  >
    <component
      :is="field.type"
      :type="field.valueType"
      v-model="data"
      :fieldErrors="fieldErrors"
      :fieldPayload="fieldPayload"
    />
  </b-field>
  <component
    v-else
    :is="field.type"
    :type="field.valueType"
    v-model="data"
    :fieldErrors="fieldErrors"
    :fieldPayload="fieldPayload"
  />
</template>

<script>
import objectPath from 'object-path'
import CSwitch from '@/lib/components/Switch'
import CInput from '@/lib/components/Input'
import CTextarea from '@/lib/components/Textarea'
import CSelect from '@/lib/components/Select'
import CCheckbox from '@/lib/components/Checkbox'
import CTagInput from '@/lib/components/TagInput'
import CMultiInput from '@/lib/components/MultiInput'
import CMultiArrayInput from '@/lib/components/MultiArrayInput'
import CMultiSelect from '@/lib/components/MultiSelect'
import CMultiCheckbox from '@/lib/components/MultiCheckbox'
// Custom
import ExchangeSources from './Custom/ExchangeSources'
import FileManager from './Custom/FileManager'
import PaymentPaysecCurrenciesWallets from './Custom/PaymentPaysecCurrenciesWallets'
import BonusCurrencyMap from './Custom/BonusCurrencyMap'
import SportsbookSource from './Custom/SportsbookSource'
import UserFields from './Custom/UserFields'
import UserPermissions from './Custom/UserPermissions'
import UserVerification from './Custom/UserVerification'
// Frontend
import FrontendRegistrationType from './Frontend/RegistrationType'
import FrontendRegistrationPasswordStrength from './Frontend/RegistrationPasswordStrength'
import IntercomOptions from './Frontend/IntercomOptions'

export default {
  name: 'field',
  props: ['value', 'field', 'errors'],
  components: {
    CSwitch,
    CInput,
    CTextarea,
    CSelect,
    CCheckbox,
    CTagInput,
    CMultiInput,
    CMultiArrayInput,
    CMultiSelect,
    CMultiCheckbox,
    // Custom
    ExchangeSources,
    SportsbookSource,
    FileManager,
    UserVerification,
    UserPermissions,
    UserFields,
    PaymentPaysecCurrenciesWallets,
    BonusCurrencyMap,
    // Frontend
    IntercomOptions,
    FrontendRegistrationType,
    FrontendRegistrationPasswordStrength,
  },
  computed: {
    data: {
      get() {
        return objectPath.get(this.value, this.path)
      },
      set(value) {
        objectPath.set(this.value, this.path, value)
      },
    },
    hasError() {
      return objectPath.has(this.errors, this.path)
    },
    fieldErrors() {
      return objectPath.get(this.errors, this.path)
    },
    errorMessage() {
      return objectPath.get(this.errors, this.path.concat([0, 'message']))
    },
    fieldPayload() {
      if (!this.field.payload) return {}
      return Object.keys(this.field.payload).reduce((acc, key) => {
        acc[key] = objectPath.get(this.value, this.field.payload[key])
        return acc
      }, {})
    },
    path() {
      // frontend configuration feature for `object-path` library
      if (this.field.path.startsWith('frontConfiguration.data')) {
        const frontPath = this.field.path
          .split('.')
          .slice(2)
          .join('.')
        return ['frontConfiguration', 'data', frontPath]
      }
      return this.field.path.split('.')
    },
  },
}
</script>

<style>
.field {
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.help.is-danger {
  flex-basis: 100%;
  margin-left: 19%;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Form/Field.vue